// extracted by mini-css-extract-plugin
export default {"footer-container":"XNCMH7yyQAt2c7xIudnq","footerContainer":"XNCMH7yyQAt2c7xIudnq"};